import { EStorageKey } from '/@/types'
import { isAppLocale } from '/@/i18n'

export const ACCEPT_LANGUAGE_HEADER = 'Accept-Language'

/** 当前界面语言，供请求头使用。不读 vue-i18n 实例，避免和请求层循环依赖。 */
export function getAcceptLanguage (): string {
  const saved = localStorage.getItem(EStorageKey.LANG_CODE)
  return isAppLocale(saved) ? saved : 'zh-CN'
}
